import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { useAppDispatch } from "cortex/ui/src/hooks";
import { addErrorMessageAction } from "cortex/ui/src/redux-store/messages";

const MESSAGES = {
  no_access_fleet:
    "You can’t access Fleet with your Vistar login. Try logging in with your Fleet email and password, or contact your account administrator.",
  incomplete: "Login attempt was cancelled or incomplete. Please try again. ",
  failed:
    "Login failed: Fleet couldn’t verify your credentials with the authentication provider. Please try again, and contact support if this persists.",
  missing_id:
    "Login failed: the authentication provider returned an incomplete response. Please contact support if this persists.",
  no_account:
    "Login failed: your account is missing important configuration data. Please contact support.",
  no_zeus: "You don’t have access to Zeus.",
  generic:
    "Login failed: please try again, and contact support if this persists",
  auth_failed: "Wrong email or password.",
};

export default function Auth0CallbackHandler() {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const error = params.get("error");
    if (!error) {
      return;
    }

    const errorKey = error as keyof typeof MESSAGES;
    const errorDescription = MESSAGES[errorKey] || MESSAGES.generic;
    dispatch(addErrorMessageAction(errorDescription));
    params.delete("error");

    history.replace({
      search: params.toString(),
    });
  }, [dispatch, location, history]);

  return null;
}
